"use strict";

export default class UpdateFac {
  static get UID() {
    return 'updateFac';
  }

  constructor($http, siteConst, BASE_URLS) {
    'ngInject';
    Object.assign(this, { $http, siteConst, BASE_URLS } );
  }


  getUpdates(count, skip) {
    var url = `${this.BASE_URLS.API}/api/site/${this.siteConst.id}/updates/${count}`;

    url += (skip !== undefined && !isNaN(skip)) ? '/' + skip : '';

    return this.$http.get(url);
  }

  getFutureUpdates(count) {
    var url = `${this.BASE_URLS.API}/api/site/${this.siteConst.id}/updates/${count}/future`;

    return this.$http.get(url);
  }

  getUpdate(updateId) {
    var url = `${this.BASE_URLS.API}/api/update/${updateId}`;

    return this.$http.get(url);
  }

  getRelatedUpdates(updateId, count) {
    count = isNaN(count) === false ? count : 3;

    var url = `${this.BASE_URLS.API}/api/update/${updateId}/related/${count}`;

    return this.$http.get(url);
  }

  static factory($http, siteConst, BASE_URLS) {
    return new UpdateFac($http, siteConst, BASE_URLS);
  }
}

UpdateFac.factory.$inject = UpdateFac.$inject



// WEBPACK FOOTER //
// ./~/site_core/src/factories/updateFac.js